<template>
  <div style="height: 100%; overflow-y: auto">
    <b-card class="sa-card" header="Consenso" header-tag="header" footer-tag="footer" title="">
      <b-row>
        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label-data">Struttura:</label>
          {{ getStrutturaLabel(localData.codiceStruttura) }}
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label-data">Nome Consenso:</label>
          <span>{{ localData.nomeConsenso }}</span>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label-data">Nome Report:</label>
          <span>{{ localData.reportName }}</span>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label-data">Sezione:</label>
          <span>{{ localData.sezione }}</span>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label-data">Descrizione:</label>
          <span :value="localData.descrizione"></span>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label-data">Tipologia:</label>
          <span>{{ localData.tipologia }}</span>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <b-row>
            <b-col cols="10"><label class="sa-label-data">Contenuto Consenso:</label> <b-embed type="iframe" v-show="showPdf" :src="pdfViewer" allowfullscreen></b-embed></b-col>
            <b-col cols="2"></b-col>
          </b-row>

          <!-- <div id="testoconsenso" v-html="localData.testoConsenso"></div> -->
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import html2pdf from "html2pdf.js";
export default {
  data() {
    return {
      localData: {
        nomeConsenso: "",
        tipologia: null,
        reportName: "",
        sezione: "",
        descrizione: "",
        codiceStruttura: null,
        testoConsenso: null,
      },
      showPdf: false,
      pdfViewer: null,
      content: "TEST",
      linkStrutture: "/strutture",
      strutturaOptions: [],
      linkedit: "",
    };
  },
  watch: {
    content(newVal) {
      this.localData.testoConsenso = newVal;
    },
  },
  mounted() {
    this.loadStrutture();
  },
  methods: {
    init(jsonData) {
      if (jsonData) {
        this.localData = JSON.parse(JSON.stringify(jsonData));
        this.generaPdf();
      } else {
        this.resetLocalData();
      }
    },
    resetLocalData() {
      this.localData = {
        nomeConsenso: "",
        tipologia: null,
        reportName: "",
        sezione: "",
        descrizione: "",
        codiceStruttura: null,
        testoConsenso: "",
      };
    },
    getStrutturaLabel(struttura) {
      return struttura;
    },
    loadStrutture() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.linkStrutture, null, me.loadStruttureSuccess, me.loadStruttureError);
    },
    loadStruttureSuccess(response) {
      let me = this;
      me.strutturaOptions = [];
      me.strutturaOptions = response.data.data;
    },
    loadStruttureError(error) {
      error;
    },
    generaPdf() {
      const options = {
        margin: 5,
        filename: `${this.localData.nomeConsenso}.pdf`,
        image: { type: "jpeg", quality: 0.9 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .set(options)
        .from(this.localData.testoConsenso)
        .outputPdf("datauristring")
        .then((pdfBase64) => {
          const base64 = pdfBase64.split(",")[1];

          this.pdfViewer = "data:application/pdf;base64," + base64;
          this.showPdf = true;
        });
    },

    getPdfContent() {
      return this.localData;
    },
  },
};
</script>

<style>
.tox-tinymce {
  border-radius: 6px;
}
</style>
